// extracted by mini-css-extract-plugin
export default {"cls1":"tVXYz4EnUyRxGb0AUCUd","cls2":"pl6ayZKp9eGL_4U_Xc5m tVXYz4EnUyRxGb0AUCUd"};